import { UseCase } from "../../base";
import { LocationsRepository } from "../../repositories";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({providedIn: 'root'})
export class DeletePublicLocationUsecase implements UseCase<string, boolean> {
  constructor(private locationRepository: LocationsRepository) {
  }

  execute(publicLocationId: string): Observable<boolean> {
    return this.locationRepository.deletePublicLocation(publicLocationId);
  }
}
